import { render, staticRenderFns } from "./detectionreport_pc.vue?vue&type=template&id=705b8ac7&"
import script from "./detectionreport_pc.vue?vue&type=script&lang=js&"
export * from "./detectionreport_pc.vue?vue&type=script&lang=js&"
import style0 from "./detectionreport_pc.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports